<nav class="navbar navbar-expand-lg fixed-top py-3 z-3 navbar-transparent" :class="in_pricing">
  <div class="container-fluid px-4 px-lg-5">

    <!-- LEFT: BRAND LOGO -->
    <a
      href="#"
      class="navbar-brand brand-logo m-0 text-white"
      aria-label="Home"
    >
      <!-- logo -->
    </a>

    <!-- MOBILE TOGGLER -->
    <button
      class="navbar-toggler border-0 shadow-none"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#govflowNavbar"
      aria-controls="govflowNavbar"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- NAV CONTENT -->
    <div class="collapse navbar-collapse" id="govflowNavbar">

      <!-- CENTER MENU -->
      <ul class="navbar-nav mx-lg-auto gap-lg-4 text-center">
        <li class="nav-item">
          <a class="nav-link fw-medium text-white" href="#">Features</a>
        </li>
        <li class="nav-item">
          <a class="nav-link fw-medium text-white" href="#">Elements</a>
        </li>
        <li class="nav-item">
          <router-link class="nav-link fw-medium text-white" to="/pricing">
            Pricing
          </router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link fw-medium text-white" href="#">Resources</a>
        </li>
      </ul>

      <!-- RIGHT ACTIONS -->
      <div class="d-flex align-items-center gap-2 mt-3 mt-lg-0">
        <router-link
          to="/login"
          class="btn btn-outline-dark btn-sm rounded-3 px-3"
        >
          Log In
        </router-link>
        <a
          href="#"
          class="btn btn-warning btn-sm rounded-3 px-3 fw-semibold"
        >
          Get Started
        </a>
      </div>

    </div>
  </div>
</nav>
